



































import { ciTimesCircle } from '~/icons/source/solid/times-circle'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    attachments: { type: Array, required: true }
  },
  data() {
    return {
      allowedImages: ['image/jpeg', 'image/jpg', 'image/png']
    }
  },
  setup() {
    return { ciTimesCircle }
  },
  methods: {
    isImage(attachment) {
      if (attachment.content_type) {
        return this.allowedImages.includes(attachment.content_type)
      }

      return attachment.type && attachment.type === 'image'
    },
    imageLink(attachment) {
      if (attachment.domain && attachment.file) {
        return attachment.domain + attachment.file
      } else if (attachment.thumb) {
        return attachment.thumb
      }

      return ''
    }
  }
})
